export const isSearchLoading = state => state.Search.loading;
export const searchResults = state => state.Search.results;
export const getSearchTerm = state => state.Search.searchTerm;
export const getInitSearch = state => state.Search.initSearch;
export const getInitValueApplied = state => state.Search.initValueApplied;
export const getFocusedResultIndex = state => state.Search.focusedResultIndex;
export const getActiveSection = state => state.Search.activeSection;
